import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Menu from "../Menu";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const UpdateHtmlDocFile = () => {
  const navigate = useNavigate();
  const { id, id2, name } = useParams(); // Get the HTML document image ID from the URL

  // State to hold form data
  const [formData, setFormData] = useState({
    id: id,
    name: "",
    remark: "",
    position: "",
    active: true,
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");

  // Fetch the existing data for the HTML document image
  useEffect(() => {
    if (id) {
      const fetchHtmlDocImageData = async () => {
        const token = getCookie("token");
        const userid = getCookie("userid");

        if (!token || !userid) {
          console.error("Missing token or userId in localStorage");
          return;
        }

        try {
          const response = await axios.post(
            'https://api.dqr-display-tms.bonrix.in/api/HtmlDocInfoOperation/SubUser/Search',
            { id: id },
            {
              headers: {
                "X-Authorization": token,
                UserId: userid,
                "Content-Type": "application/json-patch+json",
              },
            }
          );

          if (response.data && response.data.data && response.data.data.length > 0) {
            const imageData = response.data.data[0];
            setFormData({
              id: imageData.id,
              name: imageData.name || "",
              remark: imageData.remark || "",
              position: imageData.position || "",
              active: imageData.active,
            });
          }
        } catch (error) {
          console.error("Error fetching HTML document image data:", error);
          setMessage("Failed to fetch HTML document image data.");
        }
      };

      fetchHtmlDocImageData();
    }
  }, [id]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page

    // Validation
    if (!formData.remark) {
      setMessage("Please fill in all required fields.");
      return;
    }

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const updateData = {
      id: formData.id,
      name: formData.name,
      remark: formData.remark,
      position: formData.position,
      active: formData.active,
    };

    try {
      await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/HtmlDocInfoOperation/SubUser/Update',
        updateData,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      setMessage("HTML Document image updated successfully!");

      setTimeout(() => {
        navigate(`/showhtmldoc/${id2}/${name}`);
      }, 3000);
    } catch (error) {
      console.error(error);
      setMessage("Failed to update HTML document image.");
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Update HTML Document Image</h3>
                    </div>
                    <div className="card-body">
                      <form id="update-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Image Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter image name..."
                                name="name"
                              />
                            </div>
                            <div className="form-group">
                              <label>Image Description</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter image description..."
                                name="remark"
                              />
                            </div>
                            <div className="form-group">
                              <label>Position</label>
                              <input
                                type="number"
                                className="form-control"
                                value={formData.position}
                                onChange={handleChange}
                                placeholder="Enter position..."
                                name="position"
                              />
                            </div>
                            <div className="form-group">
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={formData.active}
                                  onChange={handleChange}
                                  name="active"
                                />
                                <label className="form-check-label">Active</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="update-sub"
                            className="btn btn-info"
                          >
                            Update Image
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "HTML Document image updated successfully!" ? (
       <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message === "Please fill in all required fields." ? (
       <FailedMessage message={message} />
      ) : (
        ""
      )}

      {message === "Failed to update HTML document image." ? (
       <FailedMessage message={message} />
      ) : (
        ""
      )}

      {message === "Failed to fetch HTML document image data." ? (
       <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default UpdateHtmlDocFile;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
